import { HttpHeaders } from '@angular/common/http';
import { AbstractControl, FormControl, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { DadosSelectInterface } from '@wbatd/design-system-wba';
import * as moment from 'moment';

export let pageSizeOptionsUtils = [20, 50, 100, 200];
export let pageSizeTableUtils = 20;

export function getHeaders() {
  let headers = new HttpHeaders().append('Content-Type', 'application/json; charset=utf-8');
  return headers;
}

export function validateAllFormFields(formGroup: FormGroup) {
  Object.keys(formGroup.controls).forEach((field) => {
    const control = formGroup.get(field);
    if (control instanceof FormControl) {
      control.markAsTouched({ onlySelf: true });
    } else if (control instanceof FormGroup) {
      validateAllFormFields(control);
    }
  });
}

export function colocaMascaraCnpjCpf(cnpjCpf: any) {
  if (cnpjCpf.toString().length == 14) {
    return cnpjCpf.toString().replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
  } else if (cnpjCpf.toString().length == 11) {
    return cnpjCpf.toString().replace(/^(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
  }

  return '';
}

export function retornaLabelProduto(label: string) {
  let result = '';
  switch (label) {
    case 'WBA_WEB':
      result = 'WBA WEB';
      break;
    case 'ICARTA':
      result = 'iCarta';
      break;
  }

  return result;
}

export function convertEnumToSelectItem(ennum: any) {
  var tt = [];

  var k = Object.keys(ennum);
  var v = Object.values(ennum);

  for (let i = 0; i < k.length; i++) {
    tt.push({ nome: <any>v[i], id: <any>k[i] });
  }

  return tt;
}

export function verificaFormRequired(formLabel: string, form: any) {
  let obj: any = new FormGroup({});
  obj = form;

  if (obj.controls[formLabel].errors && obj.controls[formLabel].errors.required) {
    return true;
  }

  return false;
}

export function checkAddColumnDisabled(column: any, num: number, colunasSelecionadas: any) {
  let colunaEstaSelecionada = colunasSelecionadas.some((item: any) => {
    return item == column;
  });
  if (colunasSelecionadas.length === 1 && colunaEstaSelecionada) return true;
  if (colunasSelecionadas.length > num && !colunaEstaSelecionada) {
    return true;
  }
  return false;
}

export function getCorEApelidoEmpresa(
  idEmpresa: string,
  list: any,
  idPk: boolean = false,
  idCompleto: boolean = false,
) {
  let lancamento = { apelidoEmpresa: '', corEmpresa: '#8a9199' };
  let empresa;

  if (idPk) {
    empresa = list.find((e: any) => e.idPk == `${e.tenant}:${idEmpresa}`);
  } else {
    empresa = list.find((e: any) => e.id == `${e.tenant}:${idEmpresa}`);
  }

  if (idCompleto) {
    empresa = list.find((e: any) => e.idPk == `${idEmpresa}`);
  }

  if (empresa) {
    if (!empresa.apelido) {
      lancamento.apelidoEmpresa = empresa.nome;
    } else {
      lancamento.apelidoEmpresa = empresa.apelido;
    }
    lancamento.corEmpresa = empresa.cor;
  }

  return lancamento;
}

export function decodeAndDownload(file: any) {
  const byteCharacters = atob(file.fileContent);
  const byteNumbers = new Array(byteCharacters.length);
  for (let i = 0; i < byteCharacters.length; i++) {
    byteNumbers[i] = byteCharacters.charCodeAt(i);
  }
  const byteArray = new Uint8Array(byteNumbers);
  const blob = new Blob([byteArray], { type: file.contentType });
  let link = document.createElement('a');
  link.href = window.URL.createObjectURL(blob);
  link.download = file.fileName;
  link.click();
}

export function validaCampoVazio(formGroup: FormGroup, model: any, formControl: any) {
  let regex = new RegExp(/^[ \t]+$/);

  if (regex.test(model)) {
    formGroup.controls[formControl].setErrors({ formControl: true });
  }
}

export function convertEnumToWSelectItem(ennum: any) {
  var tt: DadosSelectInterface[] = [];

  var k = Object.keys(ennum);
  var v = Object.values(ennum);

  for (let i = 0; i < k.length; i++) {
    tt.push({ nome: <any>v[i], id: <any>k[i] });
  }

  return tt;
}

export function formataData(data: string, MostrahoraMinuto: boolean = false) {
  let dataFormat = '';
  let dataFormatBloco: any;
  let dataMesDiaAno: any;
  let horaMinuto: any;

  if (data) {
    dataFormatBloco = data.split('T');
    dataMesDiaAno = dataFormatBloco[0].split('-');
    horaMinuto = dataFormatBloco[1].split('.')[0].split(':');
  }

  if (data && MostrahoraMinuto) {
    return (dataFormat = `${dataMesDiaAno[2]}/${dataMesDiaAno[1]}/${dataMesDiaAno[0]} ${horaMinuto[0]}:${horaMinuto[1]}`);
  } else if (data && !MostrahoraMinuto) {
    return (dataFormat = `${dataMesDiaAno[2]}/${dataMesDiaAno[1]}/${dataMesDiaAno[0]}`);
  }

  return dataFormat;
}

export function mascaraDigitacaoData(model: any) {
  const pattern = /[0-9]/;
  const inputChar = String.fromCharCode(model.charCode);
  if (!pattern.test(inputChar)) {
    model.preventDefault();
    return;
  }

  var v = model.target.value;
  if (v.match(/^\d{2}$/) !== null) {
    model.target.value = v + '/';
  } else if (v.match(/^\d{2}\/\d{2}$/) !== null) {
    model.target.value = v + '/';
  }
}

const dutchRangeLabel = (page: number, pageSize: number, length: number) => {
  if (length == 0 || pageSize == 0) {
    return `0 de ${length}`;
  }

  length = Math.max(length, 0);

  const startIndex = page * pageSize;

  const endIndex = startIndex < length ? Math.min(startIndex + pageSize, length) : startIndex + pageSize;

  return `${startIndex + 1} - ${endIndex} de ${length}`;
};

export function CustomPaginator() {
  const customPaginatorIntl = new MatPaginatorIntl();

  customPaginatorIntl.itemsPerPageLabel = 'Itens por pagina:';
  customPaginatorIntl.nextPageLabel = 'Próxima pagina';
  customPaginatorIntl.previousPageLabel = 'Voltar pagina';
  customPaginatorIntl.firstPageLabel = 'Primeira página';
  customPaginatorIntl.lastPageLabel = 'Última página';
  customPaginatorIntl.getRangeLabel = dutchRangeLabel;

  return customPaginatorIntl;
}

export function validaCpfCnpj(campo: string) {
  let item = campo.trim().replace('.', '').replace('.', '').replace('/', '').replace('-', '');

  if (item.length == 11) {
    return validaCpf(item);
  } else if (item.length == 14) {
    return validaCNPJ(item);
  }

  return false;
}

function validaCpf(cpf: any) {
  cpf = cpf.replace(/\D/g, '');
  if (cpf.toString().length != 11 || /^(\d)\1{10}$/.test(cpf)) return false;
  var result = true;
  [9, 10].forEach(function (j) {
    var soma = 0,
      r;
    cpf
      .split(/(?=)/)
      .splice(0, j)
      .forEach(function (e: any, i: any) {
        soma += parseInt(e) * (j + 2 - (i + 1));
      });
    r = soma % 11;
    r = r < 2 ? 0 : 11 - r;
    if (r != cpf.substring(j, j + 1)) result = false;
  });
  return result;
}

function validaCNPJ(cnpj: any) {
  var b = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
  var c: any = String(cnpj).replace(/[^\d]/g, '');

  if (c.length !== 14) return false;

  if (/0{14}/.test(c)) return false;

  for (var i = 0, n = 0; i < 12; n += c[i] * b[++i]);
  if (c[12] != ((n %= 11) < 2 ? 0 : 11 - n)) return false;

  for (var i = 0, n = 0; i <= 12; n += c[i] * b[i++]);
  if (c[13] != ((n %= 11) < 2 ? 0 : 11 - n)) return false;

  return true;
}

export function enumConvert(nomeEnum: any, item: any) {
  let x = Object.keys(nomeEnum).findIndex((y) => y == item);

  if (x != -1) {
    return Object.values(nomeEnum)[x];
  }

  return '';
}

export function getDataformat(timestamp: any) {
  let data = timestamp;
  let novaData = new Date(data);

  return `${novaData.getDate().toString().length == 2 ? novaData.getDate() : '0' + novaData.getDate()}/${
    (novaData.getMonth() + 1).toString().length == 2 ? novaData.getMonth() + 1 : '0' + (novaData.getMonth() + 1)
  }/${novaData.getFullYear()}`;
}

// para utilizar essa func, no ts é necessário ter uma variavel de copia onde essa lista, com somente a pagina atual será retornada
export function retornaPaginacao(lista: Array<any>, quantidade?: number | any, event?: any) {
  let paginaInicio = event ? event.pageIndex * event.pageSize : 0;
  let pageSize = event ? event.pageSize : 0;
  let paginaFim = paginaInicio + pageSize;
  let listaFinal: any = [];
  let copiaLista = JSON.parse(JSON.stringify(lista));
  let quantidadeConvert = quantidade ? quantidade - 1 : 0;

  if (lista) {
    copiaLista.map((x: any, index: any) => {
      if (event) {
        // setas da paginação
        if (index >= paginaInicio && index <= paginaFim - 1) {
          listaFinal.push(x);
        }
      } else {
        // inicio da tabela
        if (index <= quantidadeConvert) {
          listaFinal.push(x);
        }
      }
    });
  }

  return listaFinal;
}

export function setCookie(cname: string, cvalue: string, exdays?: number) {
  if (exdays) {
    const d = new Date();
    d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
    let expires = 'expires=' + d.toUTCString();
    document.cookie = `${cname}=${cvalue};${expires};path=/`;
    return;
  }

  document.cookie = `${cname}=${cvalue}`;
}

export function getCookie(cname: string) {
  let name = cname + '=';
  let ca = document.cookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return '';
}

export function deleteCookie(nome: string) {
  document.cookie = nome + '=; expires=Thu, 01 Jan 1970 00:00:01 GMT; path=/;';
}

/**
 * Cria uma validação cruzada entre dois campos.
 * Se o campo A for preenchido, o B torna-se obrigatório (e vice-versa).
 */
export function configurarObrigatoriedadeCruzada(
  controlA: AbstractControl | null,
  controlB: AbstractControl | null,
): void {
  if (!controlA || !controlB) return;

  const vincularLogica = (origem: AbstractControl, destino: AbstractControl) => {
    origem.valueChanges.subscribe((valor) => {
      atualizarValidador(valor, destino);
    });

    atualizarValidador(origem.value, destino);
  };

  const atualizarValidador = (valor: any, controleDestino: AbstractControl) => {
    if (valor !== null && valor !== undefined && valor !== '') {
      controleDestino.addValidators(Validators.required);
    } else {
      controleDestino.removeValidators(Validators.required);
    }
    controleDestino.updateValueAndValidity({ emitEvent: false });
  };

  vincularLogica(controlA, controlB);
  vincularLogica(controlB, controlA);
}

/**
 * Cria uma validação cruzada de valores Min e Max entre dois campos.
 * Quando o valor 'Min' muda, define o 'Max' como o validador mínimo do outro campo e vice-versa.
 * * ATENÇÃO: Esta função usa setValidators, o que substitui outros validadores (como required).
 */
export function configurarValidacaoMinMax(
  controlMin: AbstractControl | null,
  controlMax: AbstractControl | null,
): void {
  if (!controlMin || !controlMax) return;

  const atualizarValidacao = (origem: AbstractControl, destino: AbstractControl, tipo: 'min' | 'max') => {
    const valor = origem.value;

    if (valor !== null && valor !== undefined && valor !== '') {
      if (tipo === 'max') {
        destino.setValidators([Validators.min(valor)]);
      } else {
        destino.setValidators([Validators.max(valor)]);
      }
    } else {
      destino.clearValidators();
    }
    destino.updateValueAndValidity({ emitEvent: false });
  };

  controlMin.valueChanges.subscribe(() => {
    atualizarValidacao(controlMin, controlMax, 'max');
  });

  controlMax.valueChanges.subscribe(() => {
    atualizarValidacao(controlMax, controlMin, 'min');
  });

  if (controlMin.value) atualizarValidacao(controlMin, controlMax, 'max');
  if (controlMax.value) atualizarValidacao(controlMax, controlMin, 'min');
}

export function alteraPeriodo(
  event: any,
  filtroModel: any,
  periodoFunc: string,
  vencimentoDeFunc: string,
  vencimentoAteFunc: string,
) {
  if (event) {
    const periodo = event; // período selecionado
    const dataAtual = new Date(); // data atual
    const dataInicial = new Date(dataAtual.getFullYear(), dataAtual.getMonth(), dataAtual.getDate() - periodo); // data inicial
    const dataFinal = new Date(dataAtual.getFullYear(), dataAtual.getMonth(), dataAtual.getDate()); // data final

    filtroModel[periodoFunc] = periodo;
    filtroModel[vencimentoDeFunc] = dataInicial;
    filtroModel[vencimentoAteFunc] = dataFinal;
  }
}

export function alteraPeriodoFinal(event: any, filtroModel: any, self: any) {
  self.filtroModel.periodo = '';

  if (self[filtroModel].vencimentoDe && self[filtroModel].vencimentoAte) {
    self[filtroModel].periodo = calculaPeriodo(self[filtroModel]);
  }
}

function calculaPeriodo(filtro: any) {
  var d1 = moment(filtro.vencimentoDe);
  var d2 = moment(filtro.vencimentoAte);
  var d = moment.duration(d2.diff(d1));
  return d.asDays();
}
interface DateRange {
  inicio: string;
  fim: string;
  erro?: string | any;
}

export function multiDateRangeValidator(ranges: DateRange[]): ValidatorFn {
  return (form: AbstractControl): ValidationErrors | null => {
    const erros: ValidationErrors = {};

    ranges.forEach((range) => {
      const inicio = form.get(range.inicio)?.value;
      const fim = form.get(range.fim)?.value;

      if (!inicio || !fim) return;

      const dataInicio = new Date(inicio);
      const dataFim = new Date(fim);

      if (isNaN(dataInicio.getTime()) || isNaN(dataFim.getTime())) return;

      if (dataInicio > dataFim) {
        erros[range.erro] = true;

        // marca erro direto no campo "de" e "até"
        form.get(range.inicio)?.setErrors({ range: true });
        form.get(range.fim)?.setErrors({ range: true });
      }
    });

    return Object.keys(erros).length ? erros : null;
  };
}
